import './Button.scss';

export default function Button({ onClick, label }) {
  return (
    <button onClick={onClick} className="videoLand-btn cursor-pointer">
      {label}
    </button>
  );
}
